import './Toaster.css'
import type { ReactNode } from 'react'
import toast, { Toaster as ReactHotToastToaster } from 'react-hot-toast'
import { Icon } from '../graphics/Icon'
import { cn } from '@/utilities/misc'
import type { IconName } from '../graphics/iconsAvailable'
import { Button } from './Button'

const removeDelay = 100

//--------------------------------------------------------------------------------
export function toastInfo(message: ReactNode, duration = 5000) {
  const id = crypto.randomUUID()
  toast.custom(
    (<Toast id={id} variant='Info'>{message}</Toast>),
    { id, duration, removeDelay }
  )
}

//--------------------------------------------------------------------------------
export function toastSuccess(message: ReactNode, duration = 3000) {
  const id = crypto.randomUUID()
  toast.custom(
    (<Toast id={id} variant='Success' icon='check'>{message}</Toast>),
    { id, duration, removeDelay }
  )
}

//--------------------------------------------------------------------------------
export function toastWarning(message: ReactNode, duration = 5000) {
  const id = crypto.randomUUID()
  toast.custom(
    (<Toast id={id} variant='Warning' icon='exclamationTriangle'>{message}</Toast>),
    { id, duration, removeDelay }
  )
}

//--------------------------------------------------------------------------------
export function toastError(message: ReactNode, duration = 10000) {
  const id = crypto.randomUUID()
  toast.custom(
    (<Toast id={id} variant='Error' icon='exclamationTriangle'>{message}</Toast>),
    { id, duration, removeDelay }
  )
}


//--------------------------------------------------------------------------------
type ToastVariant = 'Success' | 'Error' | 'Warning' | 'Info'

type ToastProps = {
  id: string,
  variant: ToastVariant,
  icon?: IconName,
  children: ReactNode,
}


//--------------------------------------------------------------------------------
function Toast({
  id,
  variant,
  icon,
  children,
}: ToastProps) {
  return (
    <div className={cn('Toast', variant)}>
      {icon && <Icon icon={icon} />}
      <span className='Content'>
        {children}
      </span>
      <Button
        variant='raw'
        tooltip='Close'
        tooltipPlacement='top'
        className='Close'
        onClick={() => toast.dismiss(id)}
      >
        <Icon icon='times' />
      </Button>
    </div>
  )
}


//--------------------------------------------------------------------------------
export function Toaster() {
  return (
    <div id='Toaster'>
      <ReactHotToastToaster position='top-right' />
    </div>
  )
}
